export default "__VITE_ASSET__BuHrQL2f__"